import { render, staticRenderFns } from "./userPreferences.vue?vue&type=template&id=7b86aabf&"
import script from "./userPreferences.vue?vue&type=script&lang=js&"
export * from "./userPreferences.vue?vue&type=script&lang=js&"
import style0 from "./userPreferences.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports